/**
 * Auth diagnostics telemetry — fire-and-forget client → backend → CloudWatch.
 *
 * Purpose: learn why Field PWA / Admin send users back to sign-in (OTP loops)
 * without changing Cognito config or user-facing behaviour.
 *
 * Never include email, tokens, or raw Authorization headers.
 */
import { z } from 'zod';
export const AuthDiagReasonSchema = z.enum([
    'no_session_on_boot',
    'switch_user',
    'refresh_failed',
    'explicit_logout',
    'otp_signin',
    'other',
]);
export const AuthDiagEventNameSchema = z.enum([
    'auth_reauth_required',
    'session_cleared',
    'auth_signin_success',
]);
export const AuthDiagAppSchema = z.enum(['field', 'admin']);
export const AuthDiagDisplayModeSchema = z.enum(['standalone', 'browser']);
export const AuthDiagEventSchema = z.object({
    event: AuthDiagEventNameSchema,
    app: AuthDiagAppSchema,
    reason: AuthDiagReasonSchema,
    /** Whether localStorage still has a device id. */
    deviceIdPresent: z.boolean(),
    /**
     * True when the current device id differs from the one stored at the last
     * successful session write, or when a prior session write exists but the
     * device id is missing (partial storage wipe).
     */
    deviceIdLooksNew: z.boolean(),
    /** Result of navigator.storage.persisted(), or null if unavailable. */
    storagePersisted: z.boolean().nullable(),
    displayMode: AuthDiagDisplayModeSchema,
    /** Coarse OS/browser family only — never the full UA string. */
    uaFamily: z.string().max(80),
    appVersion: z.string().max(64),
    /** Hours since last successful session write; null if never written. */
    hoursSinceLastSessionWrite: z.number().finite().nullable(),
    /** Cognito `sub` if known (stashed locally or decoded from in-memory token). Never email. */
    userSub: z.string().max(128).nullable(),
});
export const AuthDiagEventRequestSchema = AuthDiagEventSchema;
//# sourceMappingURL=auth-diag.js.map